// @flow
export const REFRESH_TOKEN_REQUESTING: string = 'REFRESH_TOKEN_REQUESTING';
export const LOGIN_FAILED: string = 'LOGIN_FAILED';
export const ACCESS_TOKEN_REQUESTING: string = 'ACCESS_TOKEN_REQUESTING';
export const LOGIN_SUCCESS: string = 'LOGIN_SUCCESS';
export const UPDATE_TOKENS: string = 'UPDATE_TOKENS';
export const LOGOUT: string = 'LOGOUT';

export const REQUEST_CANDIDATE_ID_SUCCESS: string = 'REQUEST_CANDIDATE_ID_SUCCESS';
export const REQUEST_CANDIDATE_ID_FAILURE: string = 'REQUEST_CANDIDATE_ID_FAILURE';
